import { Property } from "@/types/search";

// Canonical property-detail URL. Carries the tenant id and MLS board code
// (as `mls_osn`) that the detail page needs to resolve listing display rules.
export const buildPropertyUrl = (property: Property, tenantId: string): string =>
  `/property/${property.id}?tenant_id=${tenantId}&mls_osn=${
    property.mlsBoardCode || ""
  }`;
